import React from "react";
import styles from "../drabrunadonaire/servicos_drabrunadonaire.module.scss";
import {
    Stethoscope,
    Baby,
    Scissors,
    Zap,
    Heart,
    Activity,
    ArrowLeft,
} from "lucide-react";
import WhatsappIcon from "../../icons/whatsappIcon.tsx";
import MapsIcon from "../../icons/mapsIcon.tsx";
import InstagramIcon from "../../icons/instagramIcon.tsx";
import { Link } from "react-router-dom";

const whatsappLink = (servico: string) =>
    `https://wa.me/5517981360002?text=Olá! Vim pelo seu cartão digital e gostaria de saber mais sobre ${encodeURIComponent(
        servico
    )} na Dona Vitta`;

const Servicos_drabrunadonaire: React.FC = () => {
    return (
        <div className={styles.servicos_drabrunadonaire}>
            {/* Header */}
            <div className={styles.header}>
                <Link to="/drabrunadonaire" className={styles.backButton}>
                    <ArrowLeft />
                </Link>
                <h1>Serviços</h1>
            </div>

            {/* Serviços */}
            <div className={styles.services}>
                <div className={styles.card}>
                    <Stethoscope className={styles.icon} />
                    <h3>Ginecologia Geral</h3>
                    <p>Cuidado completo em todas as fases da vida feminina.</p>
                    <a href={whatsappLink("Ginecologia Geral")} target="_blank" rel="noopener noreferrer" className={styles.agendarButton}>
                        <WhatsappIcon color="#fff" /> Agendar
                    </a>
                </div>

                <div className={styles.card}>
                    <Heart className={styles.icon} />
                    <h3>Climatério</h3>
                    <a href={whatsappLink("Climatério")} target="_blank" rel="noopener noreferrer" className={styles.agendarButton}>
                        <WhatsappIcon color="#fff" /> Agendar
                    </a>
                </div>

                <div className={styles.card}>
                    <Zap className={styles.icon} />
                    <h3>Laser em Ginecologia</h3>
                    <a href={whatsappLink("Laser em Ginecologia")} target="_blank" rel="noopener noreferrer" className={styles.agendarButton}>
                        <WhatsappIcon color="#fff" /> Agendar
                    </a>
                </div>

                <div className={styles.card}>
                    <Scissors className={styles.icon} />
                    <h3>Cirurgias Íntimas</h3>
                    <p>Procedimentos minimamente invasivos.</p>
                    <a href={whatsappLink("Cirurgia Íntima")} target="_blank" rel="noopener noreferrer" className={styles.agendarButton}>
                        <WhatsappIcon color="#fff" /> Agendar
                    </a>
                </div>

                <div className={styles.card}>
                    <Activity className={styles.icon} />
                    <h3>Implanon, DIU</h3>
                    <a href={whatsappLink("Implanon, DIU")} target="_blank" rel="noopener noreferrer" className={styles.agendarButton}>
                        <WhatsappIcon color="#fff" /> Agendar
                    </a>
                </div>

                <div className={styles.card}>
                    <Baby className={styles.icon} />
                    <h3>Pré-natal</h3>
                    <a href={whatsappLink("Pré-natal")} target="_blank" rel="noopener noreferrer" className={styles.agendarButton}>
                        <WhatsappIcon color="#fff" /> Agendar
                    </a>
                </div>

                <div className={styles.card}>
                    <Baby className={styles.icon} />
                    <h3>Partos Respeitosos</h3>
                    <a href={whatsappLink("Partos Respeitosos")} target="_blank" rel="noopener noreferrer" className={styles.agendarButton}>
                        <WhatsappIcon color="#fff" /> Agendar
                    </a>
                </div>
            </div>

            {/* Footer */}
            <div className={styles.footer}>
                <p className={styles.footerTitle}>
                    Dra. Bruna Donaire • Ginecologia e Obstetrícia
                </p>
                <p className={styles.footerSubtitle}>
                    Seja Dona • Seja Vitta
                </p>

                <div className={styles.footerLinks}>
                    <a
                        href="https://www.instagram.com/drabrunadonaire?igsh=MWM2ZGVmbmF3OXI0bQ=="
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <InstagramIcon color="#456345" height="28" />
                    </a>
                    <a
                        href="https://maps.app.goo.gl/i5ygw1tv3QZEUeq88"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <MapsIcon color="#456345" height="36" />
                    </a>
                </div>
            </div>

            {/* Botão WhatsApp flutuante */}
            <a
                href="https://wa.me/5517981360002?text=Olá! Vim pelo seu cartão digital e gostaria de agendar uma consulta na Dona Vitta."
                className={styles.whatsappFloat}
                target="_blank"
                rel="noopener noreferrer"
            >
                <WhatsappIcon color="#fff" />
            </a>
        </div>
    );
};

export default Servicos_drabrunadonaire;
